/**
 * Canonical banner detail-line formatter — 'location · salary', present-parts-only,
 * never 'undefined' or a dangling separator.
 *
 * VERBATIM JS port of backend/banner_service.py::format_detail_line (spec §4) — the
 * backend builds the live carousel feed with the Python copy; this port feeds the
 * wizard/edit-modal live previews. The pytest fixtures in
 * backend/tests/test_banner_service.py are the sync contract — if one side changes,
 * change the other.
 */

const formatSalary = (job) => {
  const smin = job?.salary_min;
  const smax = job?.salary_max;
  if (!smin && !smax) return '';
  const period = job?.salary_period || '';
  const suffix = period === 'daily' ? '/day' : (period ? '/month' : '');
  const lo = smin ? `₱${Number(smin).toLocaleString('en-US')}` : '₱0';
  const hi = smax ? ` - ₱${Number(smax).toLocaleString('en-US')}` : '';
  return `${lo}${hi}${suffix}`;
};

const formatLocation = (job) => {
  const locs = (job?.locations || (job?.location ? [job.location] : [])).filter(Boolean);
  if (locs.length === 0) return '';
  return locs.length === 1 ? locs[0] : `${locs[0]} +${locs.length - 1} more`;
};

export const formatBannerDetail = (job) => {
  const parts = [formatLocation(job), formatSalary(job)].filter(Boolean);
  return parts.join(' · ');
};

export default formatBannerDetail;
